import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-schema-map",
  "use": "icon-schema-map-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-schema-map\"><path d=\"M22.968 4a4.26 4.26 0 0 1 4.258 4.258v15.484A4.257 4.257 0 0 1 22.968 28H8.258A4.26 4.26 0 0 1 4 23.742V8.258A4.26 4.26 0 0 1 8.258 4zM8.258 6.322a1.935 1.935 0 0 0-1.936 1.936v15.484a1.936 1.936 0 0 0 1.936 1.936h2.71V6.322zm5.032 19.356h4.646V6.322H13.29zm6.968 0h2.71a1.936 1.936 0 0 0 1.935-1.936V8.258a1.935 1.935 0 0 0-1.935-1.936h-2.71z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol